import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  leadingIcon?: IconProp;
  trailingIcon?: IconProp;
};
export function ButtonGroupButton({
  leadingIcon,
  trailingIcon,
  className,
  ...props
}: Props): React.JSX.Element {
  return (
    <button
      type="button"
      {...props}
      className={clsx(
        'relative inline-flex cursor-pointer items-center justify-center bg-slate1 px-3 py-2 text-sm font-semibold text-slate12 ring-1 ring-slate6 ring-inset hover:bg-slate3 focus-visible:z-10 focus-visible:bg-slate3 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:text-slate11 disabled:opacity-50 disabled:hover:bg-slate1',
        className
      )}
    >
      {leadingIcon && (
        <FontAwesomeIcon
          icon={leadingIcon}
          className="mr-2 text-slate11"
          aria-hidden="true"
        />
      )}
      {props.children}
      {trailingIcon && (
        <FontAwesomeIcon
          icon={trailingIcon}
          className="ml-2 text-slate11"
          aria-hidden="true"
        />
      )}
    </button>
  );
}

ButtonGroupButton.displayName = 'ButtonGroupButton';
